class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.eventListeners();
  }

  connectedCallback() {


    [...document.querySelectorAll('[js-trigger="mobile-menu-button"]')].forEach((element) => {

    element.addEventListener('click', () => {

      this.classList.add('flex');
      this.classList.remove('hidden');
      document.querySelector('#mobile-menu-overlay').classList.add('flex');
      document.querySelector('#mobile-menu-overlay').classList.remove('hidden');
      document.querySelector('body').classList.add('overflow-hidden');

      setTimeout(() => {
        this.classList.add('active')
        document.querySelector('#mobile-menu-overlay').classList.add('active');
      });
    });
  });


    this.addEventListener('click', (e) => {

      if (e.target.classList == this.classList || e.target.id == "mobile-menu-button-close") {
        this.classList.remove('active')
        document.querySelector('#mobile-menu-overlay').classList.remove('active');

        // setTimeout(() => {
          this.classList.remove('flex');
          this.classList.add('hidden');
          document.querySelector('#mobile-menu-overlay').classList.remove('flex');
          document.querySelector('#mobile-menu-overlay').classList.add('hidden');
          document.querySelector('body').classList.remove('overflow-hidden');
        // }, 800);

      }

    })


    document.addEventListener('DOMContentLoaded', function() {
      const childItems = document.querySelectorAll('.mobile-nav__child-item');

      childItems.forEach(function(item) {
        item.addEventListener('click', function() {
          const grandchildContainers = document.querySelectorAll('.mobile-nav__grandchild-container');
          const grandchildContainer = this.nextElementSibling;

          grandchildContainers.forEach(function(container) {
            if (container !== grandchildContainer) {
              container.classList.add('hidden');
              container.style.maxHeight = '0';
            }
          });

          grandchildContainer.classList.toggle('hidden');

          if (grandchildContainer.classList.contains('hidden')) {
            grandchildContainer.style.maxHeight = '0';
          } else {
            grandchildContainer.style.maxHeight = grandchildContainer.scrollHeight + 'px';
          }

          childItems.forEach(function(otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('opened');
            }
          });
          this.classList.toggle('opened');
        });
      });
    });



  }

  subMenuOpen(e) {
    e.preventDefault();
    e.stopPropagation();
    const subMenu = e.target.closest('[data-trigger-menu]').getAttribute('data-trigger-menu');
    const subMenuElement = document.querySelector(`[data-menu="${subMenu}"]`);


    subMenuElement.classList.remove('translate-x-full');
    subMenuElement.classList.add('translate-x-0');

  }

  subMenuClose(e) {
    e.preventDefault();
    e.stopPropagation();

    const subMenu = e.target.closest('[data-close-menu]').getAttribute('data-close-menu');
    const subMenuElement = document.querySelector(`[data-menu="${subMenu}"]`);


    subMenuElement.classList.add('translate-x-full');
    subMenuElement.classList.remove('translate-x-0');
  }

  eventListeners() {
    [...document.querySelectorAll('[data-trigger-menu]')].forEach((element) => {
      element.addEventListener('click', this.subMenuOpen);
    });
    [...document.querySelectorAll('[data-close-menu]')].forEach((element) => {
      element.addEventListener('click', this.subMenuClose);
    });

  }


}

customElements.define('mobile-menu', MobileMenu);
